type AppleSignInButtonProps = {
  label: string;
  loadingLabel: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void | Promise<void>;
};

function AppleGlyph({ className }: { className?: string }): JSX.Element {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <path
        fill="currentColor"
        d="M16.68 12.71c.01 1.85 1.62 2.47 1.64 2.48-.01.04-.25.86-.82 1.69-.49.72-1 1.44-1.81 1.45-.8.02-1.06-.47-1.97-.47-.91 0-1.2.46-1.95.49-.78.03-1.37-.78-1.86-1.5-1-1.45-1.77-4.1-.74-5.88.51-.89 1.42-1.45 2.41-1.47.75-.02 1.46.51 1.96.51.49 0 1.4-.63 2.36-.54.4.02 1.53.16 2.25 1.22-.06.04-1.35.79-1.34 2.02zm-1.95-4.98c.41-.5.69-1.19.61-1.88-.59.02-1.3.39-1.72.89-.38.44-.71 1.14-.62 1.81.65.05 1.32-.33 1.73-.82z"
      />
    </svg>
  );
}

export function AppleSignInButton({
  label,
  loadingLabel,
  disabled,
  loading,
  onClick,
}: AppleSignInButtonProps): JSX.Element {
  const busy = Boolean(loading || disabled);
  return (
    <button
      type="button"
      disabled={busy}
      onClick={() => void onClick()}
      className="flex h-12 w-full items-center justify-center gap-3 rounded-lg border border-outline-variant/25 bg-on-surface font-headline text-body-md font-semibold text-surface shadow-sm transition-all hover:opacity-95 active:scale-[0.98] disabled:opacity-60 dark:bg-surface dark:text-on-surface"
    >
      <AppleGlyph className="size-5 shrink-0" />
      {loading ? loadingLabel : label}
    </button>
  );
}
